<template>
    <table-container>
        <data-iterator
            ref="iterator"
            :api="api"
            :filters.sync="filters"
            :fixed-filters="fixedFilters"
        >
            <template v-slot:actions>
                <slot name="actions"></slot>
            </template>

            <template slot-scope="{ items }">
                <d-table
                    :items="items"
                    :headers="headers"
                    :filters.sync="filters"
                    :row-select="true"
                    :row-action="true"
                    @onRowSelected="onRowSelected"
                >
                    <!-- restaurant column -->
                    <template v-slot:[`item.restaurant`]="{ item }">
                        <span class="align-right">{{
                            item.restaurant.name
                        }}</span>
                    </template>

                    <!-- adress column -->
                    <template v-slot:[`item.address`]="{ item }">
                        <span class="align-right">{{ item.address.name }}</span>
                    </template>

                    <!-- deliveryTime column -->
                    <template v-slot:[`item.deliveryTime`]="{ item }">
                        <span class="align-right">{{ item.deliveryTime }}</span>
                    </template>

                    <!-- role column -->
                    <template v-slot:[`item.userRoles`]="{ item }">
                        <template v-if="item.userRoles && item.userRoles[0]">
                            {{ $t('roles.' + item.userRoles[0].role) }} <br />
                            <span
                                v-if="item.userRoles[0].company"
                                class="lower"
                            >
                                {{ item.userRoles[0].company.name }}
                            </span>
                            <span
                                v-if="item.userRoles[0].restaurant"
                                class="lower"
                            >
                                {{ item.userRoles[0].restaurant.name }}
                            </span>
                        </template>
                    </template>

                    <!-- row actions -->
                    <template v-slot:rowActions="{ item }">
                        <edit-button :to="getEditLink(item)"></edit-button>
                        <delete-action
                            :entity-name="item.restaurant.name"
                            :entity-id="item.id"
                            :api="api"
                            @deleted="onEntityDeleted"
                            @failed="onEntityDeleteFailed"
                        ></delete-action>
                    </template>
                </d-table>
            </template>

            <!-- batch actions -->
            <template v-slot:batchActions>
                <delete-batch-action
                    :selected-ids="selectedIds"
                    :api="api"
                    @finished="onBatchDeleteFinished"
                    @finishedWithErrors="onBatchDeleteFinishedWithErrors"
                    @canceled="onBatchDeleteCanceled"
                ></delete-batch-action>
            </template>
        </data-iterator>
    </table-container>
</template>

<script>
import routeType from '@/router/routeType'
import RestApiType from '@/api/RestApiType'
import DataIteratorMixin from '@/components/mixins/DataIteratorMixin'
import DataTableMixin from '@/components/mixins/DataTableMixin'
import AuthMixin from '@/components/mixins/AuthMixin'
import SelectApiClientType from '@/api/SelectApiClientType'
import Headers from '@/pages/residentialCanteens/relations/mixins/Headers'

export default {
    mixins: [DataIteratorMixin, DataTableMixin, AuthMixin, Headers],
    props: {
        fixedFilters: {
            type: Object,
            default: () => {
                return {}
            },
        },
    },
    data() {
        return {
            api: RestApiType.RESIDENTIAL_CANTEEN_RELATIONS,
            selectApiClientType: SelectApiClientType,
        }
    },
    computed: {
        tableName() {
            return this.$t('labels.users')
        },
    },
    methods: {
        reload() {
            this.$refs.iterator.updateItems()
        },
        getEditLink(item) {
            return {
                name: routeType.RESIDENTIAL_CANTEEN_RELATIONS_EDIT,
                params: { entityId: item.id },
            }
        },
    },
}
</script>
